import { motion, AnimatePresence } from "framer-motion";
import { X, Phone, MessageCircle } from "lucide-react";
import { SITE } from "@/data/site";

export default function BookingModal({ open, onClose }) {
  const waLink = `https://wa.me/${SITE.phoneIntl.replace("+", "")}?text=${encodeURIComponent(
    SITE.whatsappMessage
  )}`;
  const telLink = `tel:${SITE.phoneIntl}`;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="booking-modal"
        >
          {/* Backdrop */}
          <motion.div
            className="absolute inset-0 bg-stone-900/60 backdrop-blur-md"
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />

          <motion.div
            className="relative w-full max-w-lg bg-[#F9F6F0] rounded-2xl shadow-2xl overflow-hidden border border-[#E6DFD3]"
            initial={{ opacity: 0, scale: 0.92, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 p-2 text-stone-500 hover:text-stone-900 transition-colors z-10"
              aria-label="Fermer"
              data-testid="booking-modal-close"
            >
              <X strokeWidth={1.5} className="w-5 h-5" />
            </button>

            <div className="p-8 md:p-12 text-center">
              <div className="inline-block mb-6">
                <div className="w-10 h-px bg-[#C5A059] mx-auto mb-3" />
                <p className="text-xs tracking-[0.3em] uppercase text-[#8B5A2B] font-body">
                  Réservation
                </p>
              </div>
              <h3 className="font-display text-3xl md:text-4xl font-light text-stone-900 mb-4">
                Réservez votre moment
              </h3>
              <p className="text-stone-600 font-light leading-relaxed mb-8 max-w-sm mx-auto">
                Choisissez la manière qui vous convient pour entrer en contact avec nous.
              </p>

              <div className="space-y-3">
                <a
                  href={waLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={onClose}
                  className="group flex items-center justify-center gap-3 w-full px-6 py-4 bg-[#25D366] text-white rounded-full font-body font-medium hover:bg-[#1ebe57] transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-emerald-500/20"
                  data-testid="booking-whatsapp-btn"
                >
                  <MessageCircle strokeWidth={1.8} className="w-5 h-5" />
                  Réserver via WhatsApp
                </a>
                <a
                  href={telLink}
                  onClick={onClose}
                  className="group flex items-center justify-center gap-3 w-full px-6 py-4 bg-stone-900 text-[#F9F6F0] rounded-full font-body font-medium hover:bg-stone-800 transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-stone-900/20"
                  data-testid="booking-call-btn"
                >
                  <Phone strokeWidth={1.8} className="w-5 h-5" />
                  Appeler directement
                </a>
              </div>

              <p className="text-xs text-stone-500 font-light mt-6">
                {SITE.phone} · Lundi au Samedi de 9h à 19h
              </p>
            </div>

            {/* Decorative bottom strip */}
            <div className="h-1 bg-gradient-to-r from-transparent via-[#C5A059] to-transparent opacity-60" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
